import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchiveAttachment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.8 0C2.14903 0 0 2.14903 0 4.8V19.2C0 21.851 2.14903 24 4.8 24H19.2C21.851 24 24 21.851 24 19.2V7.65685C24 6.59599 23.5786 5.57857 22.8284 4.82843L18.7029 0.702944C18.2529 0.252856 17.6424 0 17.0059 0H4.8ZM7.2 4.8H9C9.33137 4.8 9.6 5.06863 9.6 5.4C9.6 5.73137 9.33137 6 9 6H7.2V4.8ZM7.2 7.2H5.4C5.06863 7.2 4.8 6.93137 4.8 6.6C4.8 6.26863 5.06863 6 5.4 6H7.2V7.2ZM7.2 8.4V7.2H9C9.33137 7.2 9.6 7.46863 9.6 7.8C9.6 8.13137 9.33137 8.4 9 8.4H7.2ZM7.2 9.6H5.4C5.06863 9.6 4.8 9.33137 4.8 9C4.8 8.66863 5.06863 8.4 5.4 8.4H7.2V9.6ZM7.2 10.8V9.6H9C9.33137 9.6 9.6 9.86863 9.6 10.2C9.6 10.5314 9.33137 10.8 9 10.8H7.2ZM7.2 12H5.4C5.06863 12 4.8 11.7314 4.8 11.4C4.8 11.0686 5.06863 10.8 5.4 10.8H7.2V12ZM7.2 13.2V12H9C9.33137 12 9.6 12.2686 9.6 12.6C9.6 12.9314 9.33137 13.2 9 13.2H7.2ZM7.2 13.2V14.4H5.4C5.06863 14.4 4.8 14.1314 4.8 13.8C4.8 13.4686 5.06863 13.2 5.4 13.2H7.2ZM9 15.6V15H5.4V15.6H6V18C6 18.6627 6.53726 19.2 7.2 19.2C7.86274 19.2 8.4 18.6627 8.4 18V15.6H9ZM6.6 17.4V18C6.6 18.3314 6.86863 18.6 7.2 18.6C7.53137 18.6 7.8 18.3314 7.8 18V17.4H6.6Z",
		fill: "#FFA63D"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.5 0H17.0059C17.6424 0 18.2529 0.252856 18.7029 0.702944L24 6H18.9C17.5745 6 16.5 4.92548 16.5 3.6V0Z",
		fill: "white",
		fillOpacity: .16
	})]
});
export default SvgArchiveAttachment;
